import { Stack, Typography } from "@mui/material";
import { BorderLinearProgress } from "./BorderLinearProgress";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

export default function ContributionSalesCell({ ads, organic }) {
  if (!ads || !organic) return "-";
  return (
    <Stack
      direction="column"
      alignItems="center"
      spacing={0.5}
      justifyContent="center"
      sx={{ width: "100%", height: "100%" }}
    >
      <Stack
        direction="row"
        spacing={0.5}
        alignItems="center"
        justifyContent="space-between"
        sx={{ width: "100%" }}
      >
        <Typography
          variant="body2"
          fontWeight={500}
          sx={{ color: "#00000099", fontSize: "12px", fontWeight: 400 }}
        >
          Ads:
        </Typography>
        <Stack
          direction="row"
          spacing={0.5}
          alignItems="center"
          alignContent="center"
          justifyContent="flex-end"
          sx={{ width: "100%" }}
        >
          {ads > 50 && (
            <ErrorOutlineIcon sx={{ color: "#EF6C00", fontSize: "12px" }} />
          )}

          <Typography
            variant="body2"
            fontWeight={500}
            sx={{
              color: ads > 50 ? "#EF6C00" : "#002878",
              fontSize: "12px",
              fontWeight: 500,
            }}
          >
            {ads}%
          </Typography>
        </Stack>
      </Stack>
      <Stack sx={{ width: "100%" }}>
        <BorderLinearProgress variant="determinate" value={ads} />
      </Stack>
      <Stack
        direction="row"
        spacing={0.5}
        alignItems="center"
        justifyContent="space-between"
        sx={{ width: "100%" }}
      >
        <Typography
          variant="body2"
          fontWeight={500}
          sx={{ color: "#00000099", fontSize: "12px", fontWeight: 400 }}
        >
          Orgánica:
        </Typography>
        <Typography
          variant="body2"
          fontWeight={500}
          sx={{
            color: organic > 50 ? "#7B95C8" : "#939393",
            fontSize: "12px",
            fontWeight: 500,
          }}
        >
          {organic}%
        </Typography>
      </Stack>
    </Stack>
  );
}
